import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import withReducer from 'app/store/withReducer';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as Actions from './Store/Actions/PesquisaPainelActions';
import reducer from './Store/Reducers/PesquisaPainelReducer';

class TogglePesquisa extends XAPPComponent {

    componentWillUnmount() {
        const { closeAllPesquisa } = this.props;
        closeAllPesquisa();
    }

    render() {
        const { togglePesquisa, id, PesquisaPainel, closeAllPesquisa } = this.props;
        const clearPesquisa = PesquisaPainel.clearPesquisa[id];
        return (
            <React.Fragment>
                {PesquisaPainel.count[id] > 0 && !_.isNull(clearPesquisa) &&
                    <XAPPButton
                        className=""
                        onClick={() => {
                            clearPesquisa();
                            closeAllPesquisa();
                        }}
                        type="icon"
                        icon={"clear"}
                        iconProps={"text-20 text-white"}
                    />
                }
                <XAPPButton
                    className=""
                    onClick={() => togglePesquisa(id)}
                    type="icon"
                    icon={"search"}
                    iconProps={"text-20 text-white"}
                    badge={PesquisaPainel.count[id]}
                />
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        togglePesquisa: Actions.togglePesquisa,
        closeAllPesquisa: Actions.closeAllPesquisa,
    }, dispatch);
}

function mapStateToProps({ PesquisaReducer }) {
    return {
        PesquisaPainel: PesquisaReducer,
    }
}

export default withReducer('PesquisaReducer', reducer)(withRouter(connect(mapStateToProps, mapDispatchToProps)(TogglePesquisa)));
